import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService, MenuItem } from 'primeng/api';
import { XpressPaymentTransactionService } from 'app/services';
import * as moment from 'moment';
import { Utils } from 'app/utils';

enum MenuTab {
    TNXNDetails = 1,
    Products = 2,
    Payment = 3,
    Messages = 4,
    Timeline = 5
}

@Component({
    selector: 'partner-finance-transaction-detail',
    templateUrl: './partner-finance-transaction-detail.component.html',
    styleUrls: ['./partner-finance-transaction-detail.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'
    ],
    providers: [MessageService]
})
export class PartnerFinanceTransactionDetailComponent implements OnInit {
    public transactionId: number = 0;
    @Input()
    set _transactionId(value: number) {
        this.transactionId = value;
        if (this.transactionId > 0) {
            this.getTransaction();
        }
    }

    public showPartnerFinanceTransactionDetailSideBar: boolean = false;
    @Input()
    set _showPartnerFinanceTransactionDetailSideBar(value: boolean) {
        this.showPartnerFinanceTransactionDetailSideBar = value;
    }

    @Output() changedShowPartnerFinanceTransactionDetailSideBarEmit = new EventEmitter<boolean>();
    changedShowPartnerFinanceTransactionDetailSideBar(increased: any) {
        this.changedShowPartnerFinanceTransactionDetailSideBarEmit.emit(increased);
    }

    public menuTab = MenuTab;
    public activeMenuTab: MenuTab = MenuTab.TNXNDetails;
    public menuItems: MenuItem[] = [
        {
            label: 'TNXN Details',
            id: `${MenuTab.TNXNDetails}`,
            command: (e: any) => this.handleMenuTabChange(+e.item.id)
        },
        {
            label: 'Products',
            id: `${MenuTab.Products}`,
            command: (e: any) => this.handleMenuTabChange(+e.item.id)
        },
        {
            label: 'Payment',
            id: `${MenuTab.Payment}`,
            command: (e: any) => this.handleMenuTabChange(+e.item.id)
        },
        {
            label: 'Messages',
            id: `${MenuTab.Messages}`,
            command: (e: any) => this.handleMenuTabChange(+e.item.id)
        },
        {
            label: 'Timeline',
            id: `${MenuTab.Timeline}`,
            command: (e: any) => this.handleMenuTabChange(+e.item.id)
        }
    ];

    public transaction: any = {};

    public loading: boolean = false;

    constructor(
        private messageService: MessageService,
        private xpressPaymentTransactionService: XpressPaymentTransactionService) { }

    ngOnInit(): void { }

    public handleMenuTabChange(tab: MenuTab) {
        this.activeMenuTab = tab;
    }

    private getTransaction() {
        const dto = {
            TransactionId: this.transactionId
        };

        this.loading = true;

        this.xpressPaymentTransactionService.getTransactionByIdAdmin(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.transaction = data;
                this.transaction.TransactionTime = moment(Utils.utcToLocalDate(data.TransactionCreatedAt)).format('hh:mm:ss');
                this.transaction.TransactionDate = moment(data.TransactionCreatedAt).format('MMM Do YY');
                this.transaction.TransactionAmount = '₱ ' + this.transaction.TransactionAmount;
                this.transaction.DeliveryCreatedTime = moment(Utils.utcToLocalDate(data.DeliveryCreatedAt)).format('hh:mm:ss');
                this.transaction.DeliveryCompletedTime = moment(Utils.utcToLocalDate(data.DeliveryCompletedAt)).format('hh:mm:ss');
                this.transaction.DeliveryCompletedAt = moment(data.DeliveryCompletedAt).format('MMM Do YY');
                this.transaction.AcceptedTime = data.AcceptedAt ? moment(Utils.utcToLocalDate(data.AcceptedAt)).format('hh:mm:ss') : null;
                this.transaction.PackingStartedTime = data.PackingStartedAt ? moment(Utils.utcToLocalDate(data.PackingStartedAt)).format('hh:mm:ss') : null;
                this.transaction.ReadyToDispatchTime = data.ReadyToDispatchAt ? moment(Utils.utcToLocalDate(data.ReadyToDispatchAt)).format('hh:mm:ss') : null;
                this.transaction.DispatchTime = data.DispatchAt ? moment(Utils.utcToLocalDate(data.DispatchAt)).format('hh:mm:ss') : null;
                this.transaction.DeliveredTime = data.DeliveredAt ? moment(Utils.utcToLocalDate(data.DeliveredAt)).format('hh:mm:ss') : null;
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    cancel() {
        this.changedShowPartnerFinanceTransactionDetailSideBar(false);
    }
}
